import { render, staticRenderFns } from "./AccTransactions.vue?vue&type=template&id=bd2a1710"
import script from "./AccTransactions.vue?vue&type=script&lang=js"
export * from "./AccTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports